module.exports = __webpack_public_path__ + "static/media/creative-commons-sa.a4620d81.svg";